__turbopack_context__.v({
  "btn": "ImageCarousel-module__mRJvIa__btn",
  "caption": "ImageCarousel-module__mRJvIa__caption",
  "desc": "ImageCarousel-module__mRJvIa__desc",
  "favBtn": "ImageCarousel-module__mRJvIa__favBtn",
  "hasZoom": "ImageCarousel-module__mRJvIa__hasZoom",
  "image": "ImageCarousel-module__mRJvIa__image",
  "imageSlide": "ImageCarousel-module__mRJvIa__imageSlide",
  "images": "ImageCarousel-module__mRJvIa__images",
  "js-has-pseudo": "ImageCarousel-module__mRJvIa__js-has-pseudo",
  "progress": "ImageCarousel-module__mRJvIa__progress",
  "racBadge": "ImageCarousel-module__mRJvIa__racBadge",
  "shareBtn": "ImageCarousel-module__mRJvIa__shareBtn",
  "title": "ImageCarousel-module__mRJvIa__title",
  "visibleOverflow": "ImageCarousel-module__mRJvIa__visibleOverflow",
  "wrapper": "ImageCarousel-module__mRJvIa__wrapper",
});
